import { Accordion } from 'grommet'
import styled from 'styled-components'

const StyledAccordion = styled(Accordion)`
`

export { StyledAccordion }
